var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',{class:{
    'm-table-row': _vm.index >= 0,
    'm-table-row__summary': _vm.index === 0 && !_vm.isNested && _vm.withSummaryRow,
    'm-table-spacer-row': _vm.index === -1,
    'm-table-row__first': _vm.index === 0 && !_vm.isNested,
    'm-table-row_selected': Boolean(_vm.selected),
    'm-table-row_custom': _vm.color,
    'm-table-row_colored': !_vm.color,
    'm-table-row_disabled': _vm.disabled,
    'm-table-row_opened-dropdown': _vm.dropdownIsOpened,
    'm-table-row_nested-expanded': _vm.nestedRowExpanded
  },style:(_vm.cssVars)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }